<template>
    <ul class="list-group-child">
        <li class="list-group-item flex-column align-items-start tarief">
            <span
                class="remove-item"
                :class="{ 'icon-min': nr > 1 && isLast }"
                @click="deleteRate"
            />
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="tarief-intro">
                            <span>Tarief {{ nr }}</span>
                        </div>
                    </div>
                    <div
                        class="col-12 text-right tarief-prijs"
                        :class="{
                            'icon-edit': editable,
                            edit: editItem.inEditAmount
                        }"
                        @click="toggleEditAmount"
                    >
                        <span :class="{ alt: !editable }"
                            >&euro; {{ formatCurrency(editItem.amount) }}</span
                        >
                    </div>
                    <div
                        v-if="editable"
                        class="col-24 col-sm-12 text-right edit-form"
                        :class="{ edit: editItem.inEditAmount }"
                    >
                        <label class="sr-only">Tarief {{ nr }}</label>
                        <input
                            v-model="editItem.editAmount"
                            class="form-control"
                            type="text"
                        />
                        <button class="btn btn-secondary" @click="saveAmount">
                            Ok
                        </button>
                        <a class="link-cancel" @click="toggleEditAmount"
                            >cancel</a
                        >
                    </div>
                </div>
            </div>
        </li>
        <li class="list-group-item flex-column align-items-start tarief">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="tarief-intro">
                            <span>Declarabele uren</span>
                            <span class="info"
                                >Verwachting voor deze maand</span
                            >
                        </div>
                    </div>
                    <div
                        class="col-12 text-right tarief-prijs"
                        :class="{
                            'icon-edit': editable,
                            edit: editItem.inEditHours
                        }"
                        @click="toggleEditHours"
                    >
                        <span :class="{ alt: !editable }">{{
                            editItem.hours
                        }}</span>
                        <span class="info">{{ bonus.workingHours }}</span>
                    </div>
                    <div
                        v-if="editable"
                        class="col-24 col-sm-12 text-right edit-form"
                        :class="{ edit: editItem.inEditHours }"
                    >
                        <label class="sr-only">Declarabele uren</label>
                        <input
                            v-model="editItem.editHours"
                            class="form-control"
                            type="text"
                        />
                        <button class="btn btn-secondary" @click="saveHours">
                            Ok
                        </button>
                        <a class="link-cancel" @click="toggleEditHours"
                            >cancel</a
                        >
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
import EventBus from '@/shared/VueEvent';
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';

export default {
    mixins: [RockCurrencyMixin],
    props: ['bonus', 'amount', 'hours', 'nr', 'editable', 'isLast'],
    data() {
        return {
            editItem: {
                hours: 0,
                editHours: 0,
                inEditHours: false,
                amount: 0,
                editAmount: 0,
                inEditAmount: false
            }
        };
    },
    mounted() {
        this.editItem.hours = this.hours;
        this.editItem.editHours = this.hours;
        this.editItem.amount = this.amount;
        this.editItem.editAmount = this.formatCurrency(this.amount);
    },
    methods: {
        deleteRate: function (event) {
            if (this.nr > 1) {
                EventBus.fire('deleteRate', this.nr);
            }
        },
        saveHours: function () {
            this.editItem.hours = this.editItem.editHours;
            this.toggleEditHours();
            this.$emit('save', { nr: this.nr, data: this.editItem });
        },
        saveAmount: function () {
            const amount = this.formatCurrencyToNumber(
                this.editItem.editAmount
            );
            if (!isNaN(amount)) {
                this.editItem.amount = amount;
            }
            this.toggleEditAmount();
            this.$emit('save', { nr: this.nr, data: this.editItem });
        },
        getRateDetail: function () {
            return {
                amount: this.editItem.amount,
                hours: this.editItem.hours
            };
        },
        toggleEditAmount: function () {
            if (this.editable) {
                this.editItem.inEditAmount = !this.editItem.inEditAmount;
                if (this.editItem.inEditAmount) {
                    this.editItem.editAmount = this.formatCurrency(
                        this.editItem.amount
                    );
                }
            }
        },
        toggleEditHours: function () {
            if (this.editable) {
                this.editItem.inEditHours = !this.editItem.inEditHours;
                if (this.editItem.inEditHours) {
                    this.editItem.editHours = this.editItem.hours;
                }
            }
        }
    }
};
</script>
